/**
 * 获取图片缩放比例
 * @param {Object} params - 参数对象
 * @param {Object} params.ImageBox - 容器尺寸 { w, h }
 * @param {Object} params.Image - 图片尺寸 { w, h }
 * @returns {Object} 缩放比例和计算后的尺寸
 */
import { DEFAULT_MESSAGES } from '../const/constants.js';

export const getScaleRatio = ({ ImageBox, Image }) => {
  const wRatio = ImageBox?.w / Image.w;
  const hRatio = ImageBox?.h / Image.h;
  const ratio = hRatio < wRatio ? hRatio : wRatio;
  return {
    Ratio: ratio,
    ImageWidth: Image.w * ratio,
    ImageHeight: Image.h * ratio,
  };
};

/**
 * 获取图片原始尺寸
 * @param {string} url - 图片 URL
 * @param {boolean} isPdf - 是否为 PDF（未使用）
 * @returns {Promise<Object>} 图片尺寸 { width, height }
 */
export function getImgNatural(url, isPdf) {
  return new Promise(async (resolve, reject) => {
    if (!url) {
      resolve({
        width: 0,
        height: 0
      });
    }
    const temImg = new Image();
    temImg.src = url;

    temImg.onload = function () {
      console.log('实际尺寸：', temImg.width, temImg.height);
      resolve({
        width: temImg.width,
        height: temImg.height,
      });
    };
    temImg.onerror = function (err) {
      console.log('任务图片识别失败', err);
      reject(DEFAULT_MESSAGES.TASK_IMAGE_RECOGNITION_FAILED);
    };
  });
}
